import {
  Bank,
  Bridge,
  Coin,
  Cube,
  GameController,
  HandCoins,
  Handshake,
  HardDrives,
  LinkSimple,
  Money,
  ShieldCheck,
  ShoppingCart,
  Swap,
  Trophy,
  UsersThree,
  Certificate,
} from "@phosphor-icons/react"
import { type IconProps } from "@tokenterminal/core/ui/icon/Icon"

export const iconsBySlug: Record<string, IconProps["as"]> = {
  "asset-management": Bank,
  blockchains: Cube,
  "blockchains-l1": Cube,
  "blockchains-l2": Cube,
  "blockchains-l3": Cube,
  bridges: Bridge,
  derivatives: Swap,
  exchange: Money,
  gaming: GameController,
  infrastructure: HardDrives,
  insurance: ShieldCheck,
  interoperability: Handshake,
  lending: HandCoins,
  "liquid-staking": Trophy,
  nft: ShoppingCart,
  oracles: LinkSimple,
  "prediction-markets": Money,
  social: UsersThree,
  stablecoin: Coin,
  "rwa-issuers": Certificate,
}
